import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button, ButtonPropsType } from 'components/Controls/Button';
import LockSvg from './lock.svg';

interface IconButtonPropsType extends ButtonPropsType {
  iconSize?: number;
}

export const LockIcon = (props: any) => <Icon component={LockSvg} {...props} />;

export const LockIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonPropsType>(
  ({ size = 'medium', iconSize = 24, type = ButtonType.OutlineIcon, ...props }, ref) => (
    <Button
      ref={ref}
      type={type}
      icon={<LockSvg width={iconSize} height={iconSize} />}
      size={size}
      {...props}
    />
  ),
);
LockIconButton.displayName = 'LockIconButton';
